export const initialPaginationState = {
  page: 0,
  page_size: 250,
  total: 0
};

export const TROUBLE_SHOOTING_URL = "https://github.com/redhat-openshift-ecosystem/certification-releases/blob/main/containers/troubleshooting.md"
